import { createAction } from '@reduxjs/toolkit'
import { Battery, BatteryFilters } from '../../../types/api'

/**
 * Actions do módulo Catalog
 */
export const catalogActions = {
  // List batteries
  fetchBatteriesRequest: createAction<BatteryFilters | undefined>('catalog/fetchBatteriesRequest'),
  fetchBatteriesSuccess: createAction<{ batteries: Battery[]; pagination: any; filters: any }>('catalog/fetchBatteriesSuccess'),
  fetchBatteriesFailure: createAction<{ error: string }>('catalog/fetchBatteriesFailure'),
  
  // Update filters
  updateFilters: createAction<Partial<BatteryFilters>>('catalog/updateFilters'),
  
  // Get battery by ID or slug
  fetchBatteryRequest: createAction<{ id?: string; slug?: string }>('catalog/fetchBatteryRequest'),
  fetchBatterySuccess: createAction<{ battery: Battery; key: string }>('catalog/fetchBatterySuccess'),
  fetchBatteryFailure: createAction<{ error: string }>('catalog/fetchBatteryFailure'),
  
  // Get featured batteries
  fetchFeaturedBatteriesRequest: createAction('catalog/fetchFeaturedBatteriesRequest'),
  fetchFeaturedBatteriesSuccess: createAction<{ batteries: Battery[] }>('catalog/fetchFeaturedBatteriesSuccess'),
  fetchFeaturedBatteriesFailure: createAction<{ error: string }>('catalog/fetchFeaturedBatteriesFailure'),
  
  // Search batteries
  searchBatteriesRequest: createAction<{ q?: string; vehicle?: string; brand?: string; model?: string; year?: number }>('catalog/searchBatteriesRequest'),
  searchBatteriesSuccess: createAction<{ batteries: Battery[]; suggestions: string[] }>('catalog/searchBatteriesSuccess'),
  searchBatteriesFailure: createAction<{ error: string }>('catalog/searchBatteriesFailure'),
  
  // Clear battery cache
  clearBatteryCache: createAction('catalog/clearBatteryCache'),
  
  // Clear errors
  clearListError: createAction('catalog/clearListError'),
  clearBatteryError: createAction('catalog/clearBatteryError'),
}

